import React from "react";
import PropTypes from "prop-types";
import { map } from "lodash";
import { Select } from "antd";

const { Option, OptGroup } = Select;

const propTypes = {
  handlerChange: PropTypes.func,
  height: PropTypes.number,
  isClearable: PropTypes.bool,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  loadOptions: PropTypes.func,
  returnAll: PropTypes.bool,
  simple: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
    PropTypes.string,
    PropTypes.number,
  ]),
};

const defaultProps = {
  handlerChange: undefined,
  height: 40,
  isClearable: true,
  defaultValue: "",
  options: [],
  returnAll: false,
  loadOptions: undefined,
  simple: true,
  value: null,
};

function SelectInput({
  value,
  loadOptions,
  onChange,
  options,
  defaultValue,
  returnAll,
  simple,
  ...rest
}) {
  const groups = map(options, (optGroup) => {
    const groupOptions = map(optGroup.value, (optGroupOption) => (
      <Option key={optGroupOption.value} value={optGroupOption.value}>
        {optGroupOption.name}
      </Option>
    ));

    return (
      <OptGroup key={optGroup.name} label={optGroup.name}>
        {groupOptions}
      </OptGroup>
    );
  });

  return value ? (
    <Select onChange={(val) => onChange(val)} value={value} {...rest}>
      {groups}
    </Select>
  ) : (
    <Select
      onChange={(val) => onChange(val)}
      defaultValue={defaultValue}
      {...rest}
    >
      {groups}
    </Select>
  );
}

SelectInput.propTypes = propTypes;
SelectInput.defaultProps = defaultProps;

export default SelectInput;
